export const getFieldNameWithCondition = <T>(condition: boolean, fieldName: T): T | undefined => {
  if (condition) {
    return fieldName;
  }
  return undefined;
};
